/**
 * Global: Dawn scroll reveal (slide-up + fade) on each #MainContent > .shopify-section.
 * theme.liquid adds html.de-global-reveal-boot + inline CSS so sections start hidden before this
 * deferred script runs (avoids first-paint flash then hide).
 *
 * Opt out: add data-de-section-reveal-skip on an element inside a section to skip that section.
 */
(function () {
  const OFFSCREEN = 'scroll-trigger--offscreen';
  const TRIGGER = 'scroll-trigger';
  const SLIDE = 'animate--slide-in';
  const ENHANCED = 'de-section-reveal--enhanced';
  const SKIP_SEL = '[data-de-section-reveal-skip]';
  const APPLIED = 'deSectionRevealApplied';
  const HTML = document.documentElement;

  function endBoot() {
    HTML.classList.add('de-global-reveal-hydrated');
    requestAnimationFrame(function () {
      HTML.classList.remove('de-global-reveal-boot');
    });
  }

  function onIntersection(entries, observer) {
    entries.forEach((entry) => {
      const target = entry.target;
      if (entry.isIntersecting) {
        if (target.classList.contains(OFFSCREEN)) {
          target.classList.remove(OFFSCREEN);
        }
        observer.unobserve(target);
      } else {
        target.classList.add(OFFSCREEN);
      }
    });
  }

  function init() {
    const main = document.getElementById('MainContent');
    if (!main) {
      endBoot();
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      endBoot();
      return;
    }

    const list = Array.from(main.querySelectorAll(':scope > .shopify-section'));

    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: '0px 0px -40px 0px',
    });

    list.forEach((el) => {
      if (el.querySelector(SKIP_SEL)) return;
      if (el.dataset[APPLIED] === 'true') return;
      el.dataset[APPLIED] = 'true';
      el.classList.add(ENHANCED, TRIGGER, SLIDE, OFFSCREEN);
      observer.observe(el);
    });

    endBoot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
